import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const gripSecurity = defineConnector({
  identifier: "gripSecurity",
  name: "Grip Security",
  tagLine: "SaaS security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.grip\\.security/.*",
  auth: (app) =>
    headerAuth([{ name: "access-token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your Grip Security console, go to **Settings > API** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your Grip Security details",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          placeholder: "your-company.grip.security",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Grip Security domain (e.g., your-company.grip.security)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/saas`,
  },
  publicEnvVars: ({ domain }) => ({
    GRIP_SECURITY_URL: domain ? `https://${domain}` : "",
  }),
});
